import { createContext, useContext, useState } from "react";

const VideoCacheContext = createContext();

export const VideoCacheProvider = ({ children }) => {
  const [videoCache, setVideoCache] = useState(null);
  const [scrollY, setScrollY] = useState(0);

  return (
    <VideoCacheContext.Provider value={{ videoCache, setVideoCache, scrollY, setScrollY }}>
      {children}
    </VideoCacheContext.Provider>
  );
};

export const useVideoCache = () => useContext(VideoCacheContext);